export default __webpack_public_path__ + "static/media/background-iso.b6bcdc5e.svg";